(ns dashboard.services.document-list
  (:require [dashboard.services.http-config :as http-config]
            [dashboard.ui :as ui]
            [re-frame.core :as rf]))

;; Events

(rf/reg-event-fx
  ::get
  (fn [{:keys [db]} _]
    {:db (assoc-in db [:documents :loading] true)
     :http-xhrio {:method :get
                  :uri "/api/policies/"
                  :response-format http-config/transit-response-format
                  :on-success [::get-success]
                  :on-failure [::ui/set-error "Could get documents"]}}))

(rf/reg-event-db
  ::get-success
  (fn [db [_ documents]]
    (-> db
        (assoc-in [:documents :loading] false)
        (assoc-in [:documents :data] documents))))
